import comp from "./SingleDownload";
export default comp;
